import React from "react";
import PropTypes from "prop-types";
import { formatDateTimeLocal } from "utils/misc";
import { toLower } from "ramda";
import useTranslate from "hooks/use-translate-language";
import OrderDetailsModal from "./order-details-modal";

const getOrderStatusColor = status => {
  const statusColor = { backgroundColor: "white", color: "black" };
  
  switch (toLower(status)) {
    case "pending equipment":
    case "pending shipment":
    case "pending":
    case "pending buildout":
    case "pending fulfillment":
    case "coach follow up":
    case "incorrect":
    case "location assistance needed":
    case "ready for review":
    case "internal processing":
    case "ivr pending work":
      statusColor.backgroundColor = "rgb(245, 143, 8)"; 
      break;
    case "new":
    case "accepted":
      statusColor.backgroundColor = "#05294A"; // Primary
      statusColor.color = "white";
      break;
    case "rejected":
    case "voided":
    case "on hold":
    case "backordered":
      statusColor.backgroundColor = "rgb(174, 22, 62)"; 
      statusColor.color = "white";
      break;
    case "completed":
      statusColor.backgroundColor = "rgb(0, 92, 31)";
      statusColor.color = "white";
      break;
    default:
      statusColor.backgroundColor = "rgb(245, 143, 8)"; 
  }
  
  return statusColor;
};

const OrderMobileCard = ({ order }) => {
  const translate = useTranslate();

  return (
    <div className="order-mobile-card">
      <div className="mobile-card-header">
        <h3 className="sr-only">{translate("orderDate")}</h3>
        <div className="order-date">
          {formatDateTimeLocal(order.order_date)}
        </div>
        <h3 className="sr-only">{translate("status")}</h3>
        <span
          className="status-badge"
          style={getOrderStatusColor(order.status)}
        >
          {translate(toLower(order.status))}
        </span>
      </div>

      <div className="mobile-card-content">
        <h3 className="sr-only">{translate("items")}</h3>
        <div className="order-items-label">
          {translate("items")}:
        </div>
        <div className="order-items-text">
          {order.requested_equipment.map(x => translate(x)).join(", ")}
        </div>
      </div>

      <h3 className="sr-only">{translate("actions")}</h3>
      <div className="mobile-card-actions">
        <OrderDetailsModal orderId={order._id} mobileCard={true} />
      </div>
    </div>
  );
};

OrderMobileCard.propTypes = {
  order: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    order_date: PropTypes.string.isRequired,
    requested_equipment: PropTypes.arrayOf(PropTypes.string).isRequired,
    status: PropTypes.string.isRequired
  }).isRequired
};

export default OrderMobileCard;

